export const stickyHeader = () => {
	let scrollpos = window.scrollY;

	let header = document.querySelector(".main-header");
	let scrollChange = 100;
	
	let add_class_on_scroll = () => header.classList.add("sticky");
	let remove_class_on_scroll = () => header.classList.remove("sticky");
	
	window.addEventListener('scroll', function() { 
		scrollpos = window.scrollY;
	
		if (scrollpos >= scrollChange) { add_class_on_scroll() }
		else { remove_class_on_scroll() }
		
	})
}